export class InvoicePaymentTransactionItem {
    LogTransactionID: number;
    OriginalLogTransactionIDRefund: number;
    Amount: number;
    GatewayTransactionID: string;
    Description: string;
    DateTimeCreated: Date;

    public static FixDate(item: InvoicePaymentTransactionItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}


export class InvoicePaymentTransactionItemArray extends Array<InvoicePaymentTransactionItem>  {

    constructor(...items: InvoicePaymentTransactionItem[]) {
        super(...items);
        Object.setPrototypeOf(this, InvoicePaymentTransactionItemArray.prototype);
    }

    public static FixDates(item: InvoicePaymentTransactionItemArray) {
        item.forEach(x => InvoicePaymentTransactionItem.FixDate(x));
    }

}
